import { render, staticRenderFns } from "./CustomizedComments.vue?vue&type=template&id=3af2ca12&scoped=true"
import script from "./CustomizedComments.vue?vue&type=script&lang=js"
export * from "./CustomizedComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2ca12",
  null
  
)

export default component.exports